import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import TrustBar from '@/components/TrustBar';
import ServicesSection from '@/components/ServicesSection';
import StudentAccommodationSection from '@/components/StudentAccommodationSection';
import WhyChooseUsSection from '@/components/WhyChooseUsSection';
import SustainabilitySection from '@/components/SustainabilitySection';
import SectorsSection from '@/components/SectorsSection';
import ProcessSection from '@/components/ProcessSection';
import FinalCTASection from '@/components/FinalCTASection';
import Footer from '@/components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="homepage">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <StudentAccommodationSection />
        <WhyChooseUsSection />
        <SustainabilitySection />
        <SectorsSection />
        <ProcessSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
